import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './networking'
import { Swipe, SwipeItem ,Picker , Popup ,Loading , Uploader} from 'vant';
import 'vant/lib/index.css';
import $ from 'jquery';
createApp(App).use($).use(Uploader).use(store).use(router).use(Swipe).use(SwipeItem).use(Picker).use(Popup).use(Loading).mount('#app')
